import React, { useContext, useEffect, useState, useRef, createRef } from 'react'
import { 
    Container,
    LineDiv,
    ContentDiv,
    MainText,
    FilterDiv,
    BoldedFilterText,
    NormalFilterText,
    CloseImg,
    DeleteDiv,
    DeleteImg,
    DeleteText
 } from './style'
import TableFiltersContext from '../../../contexts/TableFiltersContext'
import cross from '../../../assets/stock/FiltersHeader/cross.svg'
import trash from '../../../assets/stock/FiltersHeader/trash.svg'
import SectionContext from '../../../contexts/SectionContext'

interface SymbolTable{
    [key: string]: string
}

interface Filter {
    field: string;
    type: string;
    text: string;
}

const FiltersHeader: React.FC = () => {
    const { stockFilters, setStockFilters, movementFilters, setMovementFilters } = useContext(TableFiltersContext)
    const { stockSection } = useContext(SectionContext)

    const symbolTable: SymbolTable = {
        "Começa com": "começa com",
        "Contém": "contém",
        "Não contém": "não contém",
        "Acaba com": "acaba com",
        "É igual a": "=",
        "É diferente de": "≠",
        "É maior que": "maior que",
        "É menor que": "menor que",
        "É maior/igual que": "maior ou igual que",
        "É menor/igual que": "menor ou igual que"
    }

    const deleteFilter = (index: number) => {
        if (stockSection === 'stock'){
            const newFilters = [...stockFilters]
            newFilters.splice(index, 1)
            setStockFilters(newFilters)
        } else {
            const newFilters = [...movementFilters]
            newFilters.splice(index, 1)
            setMovementFilters(newFilters)
        }
    }

    const FiltersDiv: React.FC = () => {
        if (stockSection == 'stock'){
            return(
                <ContentDiv>
                    <MainText>Filtros:</MainText>
                    {stockFilters.map((filter, index) =>                 
                    <FilterDiv key={index}>
                        <BoldedFilterText>{filter.field}</BoldedFilterText>
                        <NormalFilterText>{symbolTable[filter.type as keyof SymbolTable]}</NormalFilterText>
                        <BoldedFilterText>{filter.text}</BoldedFilterText>
                        <CloseImg src={cross} alt='Close tab image' onClick={() => deleteFilter(index)}/>
                    </FilterDiv>)}
                    <DeleteDiv onClick={() => setStockFilters([])}>
                        <DeleteImg src={trash} alt='Trash icon'/>
                        <DeleteText>Limpar</DeleteText>
                    </DeleteDiv>
                </ContentDiv>
            )
        }
        return (
            <ContentDiv>
                <MainText>Filtros:</MainText>
                {movementFilters.map((filter, index) =>                 
                <FilterDiv key={index}>
                    <BoldedFilterText>{filter.field}</BoldedFilterText>
                    <NormalFilterText>{symbolTable[filter.type as keyof SymbolTable]}</NormalFilterText>
                    <BoldedFilterText>{filter.text}</BoldedFilterText>
                    <CloseImg src={cross} alt='Close tab image' onClick={() => deleteFilter(index)}/>
                </FilterDiv>)}
                <DeleteDiv onClick={() => setMovementFilters([])}>
                    <DeleteImg src={trash} alt='Trash icon'/>
                    <DeleteText>Limpar</DeleteText>
                </DeleteDiv>
            </ContentDiv>
        )
    }

    return (
        <Container>
            <LineDiv/>
            <FiltersDiv/>
        </Container>
    )
}

export default FiltersHeader